import React from 'react';

const AnimatedCueSeshLogo = ({ className = "w-7 h-7", style = {}, isTimerActive = false }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 791.62 1080"
      style={{ ...style, enableBackground: 'new 0 0 791.62 1080' }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <style>{`
        @keyframes rotateLogoGroup {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes moveVerticalSync {
          0%, 100% {
            transform: translateY(0);
          }
          25% {
            transform: translateY(-160px);
          }
          50% {
            transform: translateY(0);
          }
          75% {
            transform: translateY(-160px);
          }
        }

        .logo-group {
          animation: ${isTimerActive ? 'rotateLogoGroup 8s linear infinite' : 'none'};
          transform-origin: center center;
        }

        .triangle-top {
          animation: ${isTimerActive ? 'moveVerticalSync 8s ease-in-out infinite' : 'none'};
        }

        .triangle-bottom {
          animation: ${isTimerActive ? 'moveVerticalSync 8s ease-in-out infinite' : 'none'};
        }
      `}</style>

      <defs>
        <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="395.8105" y1="119.3544" x2="395.8105" y2="992.9141">
          <stop offset="0" style={{ stopColor: '#EC9C55' }} />
          <stop offset="0.4089" style={{ stopColor: '#E77E50' }} />
          <stop offset="0.5932" style={{ stopColor: '#E2684C' }} />
          <stop offset="0.7497" style={{ stopColor: '#B96370' }} />
          <stop offset="0.9024" style={{ stopColor: '#955F84' }} />
          <stop offset="1" style={{ stopColor: '#80578C' }} />
        </linearGradient>
      </defs>

      <g className="logo-group">
        {/* Main S-shaped path */}
        <path
          fill="url(#SVGID_1_)"
          d="M562.15,659.74l-0.66-0.82l-97.01-104.47l-47.42,44.03l95.56,102.91c34.16,42.24,51.26,85.41,50.8,128.31
          c-0.01,1.26-0.04,2.52-0.07,3.79c-1.59,55.27-48.43,100.24-104.43,100.24H334.83c-46.1,0-86.18-29.42-99.72-73.2
          c-0.41-1.32-0.8-2.65-1.18-4c-0.29-1.01-0.56-2.02-0.82-3.03c-13.97-53.41,2.33-111.1,42.54-150.55l53.8-52.78l231.86-226.9
          c56.73-55.66,79.66-137.32,59.82-213.13c-0.37-1.41-0.75-2.82-1.15-4.23c-0.52-1.85-1.07-3.7-1.64-5.53
          c-10.73-34.7-31.92-64.43-61.27-85.97C527.8,92.92,493.13,81.57,456.8,81.57H332.7c-44.05,0-85.8,16.78-117.58,47.26
          c-31.97,30.66-50.27,71.8-51.53,115.83c-0.05,1.65-0.08,3.3-0.1,4.95c-0.62,58.7,21.58,116.11,65.98,170.65l0.66,0.82l97.01,104.47
          l47.42-44.03l-95.56-102.91c-34.16-42.24-51.26-85.41-50.8-128.31c0.01-1.26,0.04-2.52,0.07-3.79
          c1.59-55.27,48.43-100.24,104.43-100.24H456.8c46.1,0,86.18,29.42,99.72,73.2c0.41,1.32,0.8,2.65,1.18,4
          c0.29,1.01,0.56,2.02,0.82,3.03c13.97,53.41-2.33,111.1-42.54,150.55l-53.8,52.78l-231.86,226.9
          c-56.73,55.66-79.66,137.32-59.82,213.13c0.37,1.41,0.75,2.82,1.15,4.23c0.52,1.85,1.07,3.7,1.64,5.53
          c10.73,34.7,31.92,64.43,61.27,85.97c29.27,21.48,63.94,32.83,100.27,32.83h124.09c44.05,0,85.8-16.78,117.58-47.26
          c31.97-30.66,50.27-71.8,51.53-115.83c0.05-1.65,0.08-3.3,0.1-4.95C628.75,771.69,606.55,714.27,562.15,659.74z"
        />

        {/* Bottom triangle — purple (orientation is load-bearing: orange top, purple bottom) */}
        <polygon
          className="triangle-bottom"
          fill="#80578C"
          points="505.96,907.25 396.42,797.13 286.88,907.25"
        />

        {/* Top triangle — orange */}
        <polygon
          className="triangle-top"
          fill="#EC9C55"
          points="504.74,342.47 285.66,342.47 395.2,452.59"
        />
      </g>
    </svg>
  );
};

export default AnimatedCueSeshLogo;